(function(){
'use strict';

angular.module('classy').run(['$templateCache', function ($templateCache) {
  $templateCache.put('global/embedded-giving/views/partials/eg.views.partials.faq-overlay', '<div class="eg-faq eg-drawer eg-px6" data-ng-class="{\'is-open\': eg.faqOverlay.isOpened()}">\n' + '  <div class="eg-drawer-content">\n' + '    <div data-ng-include="::EmbeddedGivingPaths.views.faq"></div>\n' + '  </div>\n' + '</div>\n' + '');
}]);
})();